/**
 * Stop-loss slots row, assign modal, and update-limit modal strings missing from
 * `panelSettingsTransactions` (only partial `user.stopLoss.slots.*` existed there).
 * Merged after `panelInvestments*` so assign CTA can stay in investments partial.
 */

const es = {
  'user.stopLoss.slots.loading': 'Cargando cupos…',
  'user.stopLoss.slots.empty': 'Aún no has comprado cupos Stop-Loss.',
  'user.stopLoss.slots.protectedPlan': 'Plan protegido: {{name}}',
  'user.stopLoss.slots.principalCurrent': 'Capital: {{principal}} · Valor actual: {{current}}',
  'user.stopLoss.slots.limitPct': 'Pérdida {{pct}}%',
  'user.stopLoss.slots.distance': 'Distancia al disparo: {{amount}} ({{pct}}%)',
  'user.stopLoss.slots.changeLimit': 'Cambiar límite',
  'user.stopLoss.slots.consumedLine': 'Consumido el {{date}}',
  'user.stopLoss.slots.consumedDetail': 'Activado en {{plan}} por {{amount}}.',
  'user.stopLoss.slots.planFallback': 'Plan',
  'user.stopLoss.slots.st.active': 'Activo',
  'user.stopLoss.slots.st.consumed': 'Consumido',
  'user.stopLoss.limit.tabPercentage': 'Por porcentaje',
  'user.stopLoss.limit.tabFixed': 'Por valor fijo',
  'user.stopLoss.limit.stopsAt': 'Tu inversión se detiene en: {{amount}}',
  'user.stopLoss.limit.placeholderFixed': 'Detener cuando el valor alcance…',
  'user.stopLoss.limit.lossProtection': 'Protección de pérdida: {{amount}} ({{pct}}%)',
  'user.stopLoss.limitType.percentage': 'Porcentaje',
  'user.stopLoss.limitType.fixed': 'Fijo',
  'user.stopLoss.assign.title': 'Asignar protección Stop-Loss',
  'user.stopLoss.assign.loadingPlans': 'Cargando inversiones activas…',
  'user.stopLoss.assign.allProtected': 'Todas tus inversiones activas ya tienen protección Stop-Loss.',
  'user.stopLoss.assign.planMeta': '{{tier}} · Capital {{principal}} · Valor actual {{current}}',
  'user.stopLoss.assign.protectedPlan': 'Plan protegido: {{name}}',
  'user.stopLoss.assign.currentValue': 'Valor actual: {{amount}}',
  'user.stopLoss.assign.stopLossLimit': 'Límite stop-loss: {{amount}}',
  'user.stopLoss.assign.maxLoss': 'Pérdida máx.: {{amount}} ({{pct}}%)',
  'user.stopLoss.assign.toastFail': 'No se pudo asignar el stop-loss',
  'user.stopLoss.assign.toastOk': 'Protección Stop-Loss activada',
  'user.stopLoss.assign.activate': 'Activar protección',
  'user.stopLoss.assign.activating': 'Activando…',
  'user.stopLoss.update.title': 'Actualizar límite Stop-Loss',
  'user.stopLoss.update.currentLine': 'Límite actual: {{amount}} ({{type}})',
  'user.stopLoss.update.newValue': 'Nuevo valor stop-loss: {{amount}}',
  'user.stopLoss.update.toastFail': 'No se pudo actualizar el límite',
  'user.stopLoss.update.toastOk': 'Límite Stop-Loss actualizado',
  'user.stopLoss.update.submit': 'Actualizar límite',
  'user.stopLoss.update.updating': 'Actualizando…',
};

const de = {
  'user.stopLoss.slots.loading': 'Slots werden geladen…',
  'user.stopLoss.slots.empty': 'Noch keine Stop-Loss-Slots gekauft.',
  'user.stopLoss.slots.protectedPlan': 'Geschützter Plan: {{name}}',
  'user.stopLoss.slots.principalCurrent': 'Kapital: {{principal}} · Aktuell: {{current}}',
  'user.stopLoss.slots.limitPct': '{{pct}}% Verlust',
  'user.stopLoss.slots.distance': 'Abstand bis Auslösung: {{amount}} ({{pct}}%)',
  'user.stopLoss.slots.changeLimit': 'Limit ändern',
  'user.stopLoss.slots.consumedLine': 'Verbraucht am {{date}}',
  'user.stopLoss.slots.consumedDetail': 'Ausgelöst bei {{plan}} mit {{amount}}.',
  'user.stopLoss.slots.planFallback': 'Plan',
  'user.stopLoss.slots.st.active': 'Aktiv',
  'user.stopLoss.slots.st.consumed': 'Verbraucht',
  'user.stopLoss.limit.tabPercentage': 'Nach Prozentsatz',
  'user.stopLoss.limit.tabFixed': 'Nach festem Wert',
  'user.stopLoss.limit.stopsAt': 'Ihre Investition stoppt bei: {{amount}}',
  'user.stopLoss.limit.placeholderFixed': 'Stoppen, wenn der Wert erreicht…',
  'user.stopLoss.limit.lossProtection': 'Verlustschutz: {{amount}} ({{pct}}%)',
  'user.stopLoss.limitType.percentage': 'Prozentsatz',
  'user.stopLoss.limitType.fixed': 'Fest',
  'user.stopLoss.assign.title': 'Stop-Loss-Schutz zuweisen',
  'user.stopLoss.assign.loadingPlans': 'Aktive Investitionen werden geladen…',
  'user.stopLoss.assign.allProtected': 'Alle aktiven Investitionen sind bereits mit Stop-Loss geschützt.',
  'user.stopLoss.assign.planMeta': '{{tier}} · Kapital {{principal}} · Aktuell {{current}}',
  'user.stopLoss.assign.protectedPlan': 'Geschützter Plan: {{name}}',
  'user.stopLoss.assign.currentValue': 'Aktueller Wert: {{amount}}',
  'user.stopLoss.assign.stopLossLimit': 'Stop-Loss-Limit: {{amount}}',
  'user.stopLoss.assign.maxLoss': 'Max. Verlust: {{amount}} ({{pct}}%)',
  'user.stopLoss.assign.toastFail': 'Stop-Loss konnte nicht zugewiesen werden',
  'user.stopLoss.assign.toastOk': 'Stop-Loss-Schutz aktiviert',
  'user.stopLoss.assign.activate': 'Schutz aktivieren',
  'user.stopLoss.assign.activating': 'Aktivierung…',
  'user.stopLoss.update.title': 'Stop-Loss-Limit aktualisieren',
  'user.stopLoss.update.currentLine': 'Aktuelles Limit: {{amount}} ({{type}})',
  'user.stopLoss.update.newValue': 'Neuer Stop-Loss-Wert: {{amount}}',
  'user.stopLoss.update.toastFail': 'Limit konnte nicht aktualisiert werden',
  'user.stopLoss.update.toastOk': 'Stop-Loss-Limit aktualisiert',
  'user.stopLoss.update.submit': 'Limit aktualisieren',
  'user.stopLoss.update.updating': 'Aktualisierung…',
};

export const panelStopLossSlotsAssignByLang = { es, de };

export const panelStopLossSlotsAssignOverrides = {
  fr: {
    'user.stopLoss.slots.loading': 'Chargement des emplacements…',
    'user.stopLoss.slots.empty': 'Aucun emplacement Stop-Loss acheté pour le moment.',
    'user.stopLoss.slots.protectedPlan': 'Plan protégé : {{name}}',
    'user.stopLoss.slots.principalCurrent': 'Capital : {{principal}} · Actuel : {{current}}',
    'user.stopLoss.slots.limitPct': 'Perte {{pct}}%',
    'user.stopLoss.slots.distance': 'Distance avant déclenchement : {{amount}} ({{pct}}%)',
    'user.stopLoss.slots.changeLimit': 'Modifier la limite',
    'user.stopLoss.slots.consumedLine': 'Consommé le {{date}}',
    'user.stopLoss.slots.consumedDetail': 'Déclenché sur {{plan}} à {{amount}}.',
    'user.stopLoss.slots.planFallback': 'Plan',
    'user.stopLoss.slots.st.active': 'Actif',
    'user.stopLoss.slots.st.consumed': 'Consommé',
    'user.stopLoss.limit.tabPercentage': 'En pourcentage',
    'user.stopLoss.limit.tabFixed': 'En valeur fixe',
    'user.stopLoss.limit.stopsAt': 'Votre investissement s’arrête à : {{amount}}',
    'user.stopLoss.limit.placeholderFixed': 'Arrêter lorsque la valeur atteint…',
    'user.stopLoss.limit.lossProtection': 'Protection perte : {{amount}} ({{pct}}%)',
    'user.stopLoss.limitType.percentage': 'Pourcentage',
    'user.stopLoss.limitType.fixed': 'Fixe',
    'user.stopLoss.assign.title': 'Attribuer la protection Stop-Loss',
    'user.stopLoss.assign.loadingPlans': 'Chargement des investissements actifs…',
    'user.stopLoss.assign.allProtected': 'Tous vos investissements actifs ont déjà une protection Stop-Loss.',
    'user.stopLoss.assign.planMeta': '{{tier}} · Capital {{principal}} · Actuel {{current}}',
    'user.stopLoss.assign.protectedPlan': 'Plan protégé : {{name}}',
    'user.stopLoss.assign.currentValue': 'Valeur actuelle : {{amount}}',
    'user.stopLoss.assign.stopLossLimit': 'Limite stop-loss : {{amount}}',
    'user.stopLoss.assign.maxLoss': 'Perte max. : {{amount}} ({{pct}}%)',
    'user.stopLoss.assign.toastFail': 'Échec de l’attribution du stop-loss',
    'user.stopLoss.assign.toastOk': 'Protection Stop-Loss activée',
    'user.stopLoss.assign.activate': 'Activer la protection',
    'user.stopLoss.assign.activating': 'Activation…',
    'user.stopLoss.update.title': 'Mettre à jour la limite Stop-Loss',
    'user.stopLoss.update.currentLine': 'Limite actuelle : {{amount}} ({{type}})',
    'user.stopLoss.update.newValue': 'Nouvelle valeur stop-loss : {{amount}}',
    'user.stopLoss.update.toastFail': 'Échec de la mise à jour de la limite',
    'user.stopLoss.update.toastOk': 'Limite Stop-Loss mise à jour',
    'user.stopLoss.update.submit': 'Mettre à jour la limite',
    'user.stopLoss.update.updating': 'Mise à jour…',
  },

  ar: {
    'user.stopLoss.slots.loading': 'جاري تحميل الفتحات…',
    'user.stopLoss.slots.empty': 'لم تشتَرِ فتحات وقف الخسارة بعد.',
    'user.stopLoss.slots.protectedPlan': 'الخطة المحمية: {{name}}',
    'user.stopLoss.slots.principalCurrent': 'الرأسمال: {{principal}} · الحالي: {{current}}',
    'user.stopLoss.slots.limitPct': 'خسارة {{pct}}٪',
    'user.stopLoss.slots.distance': 'المسافة للتفعيل: {{amount}} ({{pct}}٪)',
    'user.stopLoss.slots.changeLimit': 'تغيير الحد',
    'user.stopLoss.slots.consumedLine': 'استُهلك في {{date}}',
    'user.stopLoss.slots.consumedDetail': 'تفعيل على {{plan}} بمبلغ {{amount}}.',
    'user.stopLoss.slots.planFallback': 'خطة',
    'user.stopLoss.slots.st.active': 'نشط',
    'user.stopLoss.slots.st.consumed': 'مستنفد',
    'user.stopLoss.limit.tabPercentage': 'حسب النسبة',
    'user.stopLoss.limit.tabFixed': 'حسب قيمة ثابتة',
    'user.stopLoss.limit.stopsAt': 'تتوقف استثمارك عند: {{amount}}',
    'user.stopLoss.limit.placeholderFixed': 'إيقاف عندما يصل السعر إلى…',
    'user.stopLoss.limit.lossProtection': 'حماية من الخسارة: {{amount}} ({{pct}}٪)',
    'user.stopLoss.limitType.percentage': 'نسبة مئوية',
    'user.stopLoss.limitType.fixed': 'ثابت',
    'user.stopLoss.assign.title': 'تعيين حماية وقف الخسارة',
    'user.stopLoss.assign.loadingPlans': 'جاري تحميل الاستثمارات النشطة…',
    'user.stopLoss.assign.allProtected': 'جميع استثماراتك النشطة لديها بالفعل حماية وقف خسارة.',
    'user.stopLoss.assign.planMeta': '{{tier}} · الرأسمال {{principal}} · الحالي {{current}}',
    'user.stopLoss.assign.protectedPlan': 'الخطة المحمية: {{name}}',
    'user.stopLoss.assign.currentValue': 'القيمة الحالية: {{amount}}',
    'user.stopLoss.assign.stopLossLimit': 'حد وقف الخسارة: {{amount}}',
    'user.stopLoss.assign.maxLoss': 'أقصى خسارة: {{amount}} ({{pct}}٪)',
    'user.stopLoss.assign.toastFail': 'تعذر تعيين وقف الخسارة',
    'user.stopLoss.assign.toastOk': 'تم تفعيل حماية وقف الخسارة',
    'user.stopLoss.assign.activate': 'تفعيل الحماية',
    'user.stopLoss.assign.activating': 'جاري التفعيل…',
    'user.stopLoss.update.title': 'تحديث حد وقف الخسارة',
    'user.stopLoss.update.currentLine': 'الحد الحالي: {{amount}} ({{type}})',
    'user.stopLoss.update.newValue': 'قيمة وقف الخسارة الجديدة: {{amount}}',
    'user.stopLoss.update.toastFail': 'تعذر تحديث الحد',
    'user.stopLoss.update.toastOk': 'تم تحديث حد وقف الخسارة',
    'user.stopLoss.update.submit': 'تحديث الحد',
    'user.stopLoss.update.updating': 'جاري التحديث…',
  },

  ja: {
    'user.stopLoss.slots.loading': '枠を読み込み中…',
    'user.stopLoss.slots.empty': 'ストップロスの枠はまだ購入していません。',
    'user.stopLoss.slots.protectedPlan': '保護プラン: {{name}}',
    'user.stopLoss.slots.principalCurrent': '元本: {{principal}} · 現在: {{current}}',
    'user.stopLoss.slots.limitPct': '{{pct}}% 損失',
    'user.stopLoss.slots.distance': '発動までの距離: {{amount}}（{{pct}}%）',
    'user.stopLoss.slots.changeLimit': '上限を変更',
    'user.stopLoss.slots.consumedLine': '消化日: {{date}}',
    'user.stopLoss.slots.consumedDetail': '{{plan}} で {{amount}} に発動。',
    'user.stopLoss.slots.planFallback': 'プラン',
    'user.stopLoss.slots.st.active': 'アクティブ',
    'user.stopLoss.slots.st.consumed': '消化済み',
    'user.stopLoss.limit.tabPercentage': '割合で',
    'user.stopLoss.limit.tabFixed': '固定値で',
    'user.stopLoss.limit.stopsAt': '投資が停止する価格: {{amount}}',
    'user.stopLoss.limit.placeholderFixed': '価格が到達したら停止…',
    'user.stopLoss.limit.lossProtection': '損失保護: {{amount}}（{{pct}}%）',
    'user.stopLoss.limitType.percentage': '割合',
    'user.stopLoss.limitType.fixed': '固定',
    'user.stopLoss.assign.title': 'ストップロス保護を割り当て',
    'user.stopLoss.assign.loadingPlans': '運用中の投資を読み込み中…',
    'user.stopLoss.assign.allProtected': '運用中の投資はすべてストップロス保護済みです。',
    'user.stopLoss.assign.planMeta': '{{tier}} · 元本 {{principal}} · 現在 {{current}}',
    'user.stopLoss.assign.protectedPlan': '保護プラン: {{name}}',
    'user.stopLoss.assign.currentValue': '現在価値: {{amount}}',
    'user.stopLoss.assign.stopLossLimit': 'ストップロス上限: {{amount}}',
    'user.stopLoss.assign.maxLoss': '最大損失: {{amount}}（{{pct}}%）',
    'user.stopLoss.assign.toastFail': 'ストップロスの割り当てに失敗しました',
    'user.stopLoss.assign.toastOk': 'ストップロス保護を有効化しました',
    'user.stopLoss.assign.activate': '保護を有効化',
    'user.stopLoss.assign.activating': '有効化中…',
    'user.stopLoss.update.title': 'ストップロス上限を更新',
    'user.stopLoss.update.currentLine': '現在の上限: {{amount}}（{{type}}）',
    'user.stopLoss.update.newValue': '新しいストップロス値: {{amount}}',
    'user.stopLoss.update.toastFail': '上限の更新に失敗しました',
    'user.stopLoss.update.toastOk': 'ストップロス上限を更新しました',
    'user.stopLoss.update.submit': '上限を更新',
    'user.stopLoss.update.updating': '更新中…',
  },

  ko: {
    'user.stopLoss.slots.loading': '슬롯 불러오는 중…',
    'user.stopLoss.slots.empty': '아직 스톱로스 슬롯을 구매하지 않았습니다.',
    'user.stopLoss.slots.protectedPlan': '보호 플랜: {{name}}',
    'user.stopLoss.slots.principalCurrent': '원금: {{principal}} · 현재: {{current}}',
    'user.stopLoss.slots.limitPct': '{{pct}}% 손실',
    'user.stopLoss.slots.distance': '발동까지 거리: {{amount}} ({{pct}}%)',
    'user.stopLoss.slots.changeLimit': '한도 변경',
    'user.stopLoss.slots.consumedLine': '소진일: {{date}}',
    'user.stopLoss.slots.consumedDetail': '{{plan}}에서 {{amount}}에 발동.',
    'user.stopLoss.slots.planFallback': '플랜',
    'user.stopLoss.slots.st.active': '활성',
    'user.stopLoss.slots.st.consumed': '소진',
    'user.stopLoss.limit.tabPercentage': '비율로',
    'user.stopLoss.limit.tabFixed': '고정값으로',
    'user.stopLoss.limit.stopsAt': '투자가 중지되는 금액: {{amount}}',
    'user.stopLoss.limit.placeholderFixed': '가치가 도달하면 중지…',
    'user.stopLoss.limit.lossProtection': '손실 보호: {{amount}} ({{pct}}%)',
    'user.stopLoss.limitType.percentage': '비율',
    'user.stopLoss.limitType.fixed': '고정',
    'user.stopLoss.assign.title': '스톱로스 보호 할당',
    'user.stopLoss.assign.loadingPlans': '진행 중인 투자 불러오는 중…',
    'user.stopLoss.assign.allProtected': '진행 중인 모든 투자에 이미 스톱로스가 적용되어 있습니다.',
    'user.stopLoss.assign.planMeta': '{{tier}} · 원금 {{principal}} · 현재 {{current}}',
    'user.stopLoss.assign.protectedPlan': '보호 플랜: {{name}}',
    'user.stopLoss.assign.currentValue': '현재 가치: {{amount}}',
    'user.stopLoss.assign.stopLossLimit': '스톱로스 한도: {{amount}}',
    'user.stopLoss.assign.maxLoss': '최대 손실: {{amount}} ({{pct}}%)',
    'user.stopLoss.assign.toastFail': '스톱로스 할당 실패',
    'user.stopLoss.assign.toastOk': '스톱로스 보호가 활성화되었습니다',
    'user.stopLoss.assign.activate': '보호 활성화',
    'user.stopLoss.assign.activating': '활성화 중…',
    'user.stopLoss.update.title': '스톱로스 한도 업데이트',
    'user.stopLoss.update.currentLine': '현재 한도: {{amount}} ({{type}})',
    'user.stopLoss.update.newValue': '새 스톱로스 값: {{amount}}',
    'user.stopLoss.update.toastFail': '한도 업데이트 실패',
    'user.stopLoss.update.toastOk': '스톱로스 한도가 업데이트되었습니다',
    'user.stopLoss.update.submit': '한도 업데이트',
    'user.stopLoss.update.updating': '업데이트 중…',
  },

  'zh-CN': {
    'user.stopLoss.slots.loading': '正在加载名额…',
    'user.stopLoss.slots.empty': '尚未购买止损名额。',
    'user.stopLoss.slots.protectedPlan': '受保护方案：{{name}}',
    'user.stopLoss.slots.principalCurrent': '本金：{{principal}} · 当前：{{current}}',
    'user.stopLoss.slots.limitPct': '{{pct}}% 亏损',
    'user.stopLoss.slots.distance': '距触发：{{amount}}（{{pct}}%）',
    'user.stopLoss.slots.changeLimit': '更改上限',
    'user.stopLoss.slots.consumedLine': '已于 {{date}} 用尽',
    'user.stopLoss.slots.consumedDetail': '在 {{plan}} 以 {{amount}} 触发。',
    'user.stopLoss.slots.planFallback': '方案',
    'user.stopLoss.slots.st.active': '进行中',
    'user.stopLoss.slots.st.consumed': '已用尽',
    'user.stopLoss.limit.tabPercentage': '按百分比',
    'user.stopLoss.limit.tabFixed': '按固定值',
    'user.stopLoss.limit.stopsAt': '投资将在以下价值停止：{{amount}}',
    'user.stopLoss.limit.placeholderFixed': '价值达到时停止…',
    'user.stopLoss.limit.lossProtection': '亏损保护：{{amount}}（{{pct}}%）',
    'user.stopLoss.limitType.percentage': '百分比',
    'user.stopLoss.limitType.fixed': '固定',
    'user.stopLoss.assign.title': '分配止损保护',
    'user.stopLoss.assign.loadingPlans': '正在加载进行中的投资…',
    'user.stopLoss.assign.allProtected': '您所有进行中的投资均已启用止损保护。',
    'user.stopLoss.assign.planMeta': '{{tier}} · 本金 {{principal}} · 当前 {{current}}',
    'user.stopLoss.assign.protectedPlan': '受保护方案：{{name}}',
    'user.stopLoss.assign.currentValue': '当前价值：{{amount}}',
    'user.stopLoss.assign.stopLossLimit': '止损上限：{{amount}}',
    'user.stopLoss.assign.maxLoss': '最大亏损：{{amount}}（{{pct}}%）',
    'user.stopLoss.assign.toastFail': '止损分配失败',
    'user.stopLoss.assign.toastOk': '止损保护已启用',
    'user.stopLoss.assign.activate': '启用保护',
    'user.stopLoss.assign.activating': '启用中…',
    'user.stopLoss.update.title': '更新止损上限',
    'user.stopLoss.update.currentLine': '当前上限：{{amount}}（{{type}}）',
    'user.stopLoss.update.newValue': '新止损值：{{amount}}',
    'user.stopLoss.update.toastFail': '更新上限失败',
    'user.stopLoss.update.toastOk': '止损上限已更新',
    'user.stopLoss.update.submit': '更新上限',
    'user.stopLoss.update.updating': '更新中…',
  },

  pt: {
    'user.stopLoss.slots.loading': 'A carregar vagas…',
    'user.stopLoss.slots.empty': 'Ainda não comprou vagas Stop-Loss.',
    'user.stopLoss.slots.protectedPlan': 'Plano protegido: {{name}}',
    'user.stopLoss.slots.principalCurrent': 'Principal: {{principal}} · Atual: {{current}}',
    'user.stopLoss.slots.limitPct': 'Perda {{pct}}%',
    'user.stopLoss.slots.distance': 'Distância até o disparo: {{amount}} ({{pct}}%)',
    'user.stopLoss.slots.changeLimit': 'Alterar limite',
    'user.stopLoss.slots.consumedLine': 'Consumido em {{date}}',
    'user.stopLoss.slots.consumedDetail': 'Disparado em {{plan}} a {{amount}}.',
    'user.stopLoss.slots.planFallback': 'Plano',
    'user.stopLoss.slots.st.active': 'Ativo',
    'user.stopLoss.slots.st.consumed': 'Consumido',
    'user.stopLoss.limit.tabPercentage': 'Por percentagem',
    'user.stopLoss.limit.tabFixed': 'Por valor fixo',
    'user.stopLoss.limit.stopsAt': 'O investimento para em: {{amount}}',
    'user.stopLoss.limit.placeholderFixed': 'Parar quando o valor atingir…',
    'user.stopLoss.limit.lossProtection': 'Proteção de perda: {{amount}} ({{pct}}%)',
    'user.stopLoss.limitType.percentage': 'Percentagem',
    'user.stopLoss.limitType.fixed': 'Fixo',
    'user.stopLoss.assign.title': 'Atribuir proteção Stop-Loss',
    'user.stopLoss.assign.loadingPlans': 'A carregar investimentos ativos…',
    'user.stopLoss.assign.allProtected': 'Todos os investimentos ativos já têm proteção Stop-Loss.',
    'user.stopLoss.assign.planMeta': '{{tier}} · Principal {{principal}} · Atual {{current}}',
    'user.stopLoss.assign.protectedPlan': 'Plano protegido: {{name}}',
    'user.stopLoss.assign.currentValue': 'Valor atual: {{amount}}',
    'user.stopLoss.assign.stopLossLimit': 'Limite stop-loss: {{amount}}',
    'user.stopLoss.assign.maxLoss': 'Perda máx.: {{amount}} ({{pct}}%)',
    'user.stopLoss.assign.toastFail': 'Falha ao atribuir stop-loss',
    'user.stopLoss.assign.toastOk': 'Proteção Stop-Loss ativada',
    'user.stopLoss.assign.activate': 'Ativar proteção',
    'user.stopLoss.assign.activating': 'A ativar…',
    'user.stopLoss.update.title': 'Atualizar limite Stop-Loss',
    'user.stopLoss.update.currentLine': 'Limite atual: {{amount}} ({{type}})',
    'user.stopLoss.update.newValue': 'Novo valor stop-loss: {{amount}}',
    'user.stopLoss.update.toastFail': 'Falha ao atualizar o limite',
    'user.stopLoss.update.toastOk': 'Limite Stop-Loss atualizado',
    'user.stopLoss.update.submit': 'Atualizar limite',
    'user.stopLoss.update.updating': 'A atualizar…',
  },

  it: {
    'user.stopLoss.slots.loading': 'Caricamento slot…',
    'user.stopLoss.slots.empty': 'Non hai ancora acquistato slot Stop-Loss.',
    'user.stopLoss.slots.protectedPlan': 'Piano protetto: {{name}}',
    'user.stopLoss.slots.principalCurrent': 'Capitale: {{principal}} · Attuale: {{current}}',
    'user.stopLoss.slots.limitPct': 'Perdita {{pct}}%',
    'user.stopLoss.slots.distance': 'Distanza dall’attivazione: {{amount}} ({{pct}}%)',
    'user.stopLoss.slots.changeLimit': 'Modifica limite',
    'user.stopLoss.slots.consumedLine': 'Consumato il {{date}}',
    'user.stopLoss.slots.consumedDetail': 'Attivato su {{plan}} a {{amount}}.',
    'user.stopLoss.slots.planFallback': 'Piano',
    'user.stopLoss.slots.st.active': 'Attivo',
    'user.stopLoss.slots.st.consumed': 'Consumato',
    'user.stopLoss.limit.tabPercentage': 'Per percentuale',
    'user.stopLoss.limit.tabFixed': 'Per valore fisso',
    'user.stopLoss.limit.stopsAt': 'L’investimento si ferma a: {{amount}}',
    'user.stopLoss.limit.placeholderFixed': 'Ferma quando il valore raggiunge…',
    'user.stopLoss.limit.lossProtection': 'Protezione perdita: {{amount}} ({{pct}}%)',
    'user.stopLoss.limitType.percentage': 'Percentuale',
    'user.stopLoss.limitType.fixed': 'Fisso',
    'user.stopLoss.assign.title': 'Assegna protezione Stop-Loss',
    'user.stopLoss.assign.loadingPlans': 'Caricamento investimenti attivi…',
    'user.stopLoss.assign.allProtected': 'Tutti gli investimenti attivi hanno già protezione Stop-Loss.',
    'user.stopLoss.assign.planMeta': '{{tier}} · Capitale {{principal}} · Attuale {{current}}',
    'user.stopLoss.assign.protectedPlan': 'Piano protetto: {{name}}',
    'user.stopLoss.assign.currentValue': 'Valore attuale: {{amount}}',
    'user.stopLoss.assign.stopLossLimit': 'Limite stop-loss: {{amount}}',
    'user.stopLoss.assign.maxLoss': 'Perdita max: {{amount}} ({{pct}}%)',
    'user.stopLoss.assign.toastFail': 'Impossibile assegnare lo stop-loss',
    'user.stopLoss.assign.toastOk': 'Protezione Stop-Loss attivata',
    'user.stopLoss.assign.activate': 'Attiva protezione',
    'user.stopLoss.assign.activating': 'Attivazione…',
    'user.stopLoss.update.title': 'Aggiorna limite Stop-Loss',
    'user.stopLoss.update.currentLine': 'Limite attuale: {{amount}} ({{type}})',
    'user.stopLoss.update.newValue': 'Nuovo valore stop-loss: {{amount}}',
    'user.stopLoss.update.toastFail': 'Aggiornamento limite non riuscito',
    'user.stopLoss.update.toastOk': 'Limite Stop-Loss aggiornato',
    'user.stopLoss.update.submit': 'Aggiorna limite',
    'user.stopLoss.update.updating': 'Aggiornamento…',
  },

  ru: {
    'user.stopLoss.slots.loading': 'Загрузка слотов…',
    'user.stopLoss.slots.empty': 'Слоты стоп-лосса ещё не куплены.',
    'user.stopLoss.slots.protectedPlan': 'Защищаемый план: {{name}}',
    'user.stopLoss.slots.principalCurrent': 'Капитал: {{principal}} · Текущая: {{current}}',
    'user.stopLoss.slots.limitPct': 'Потеря {{pct}}%',
    'user.stopLoss.slots.distance': 'До срабатывания: {{amount}} ({{pct}}%)',
    'user.stopLoss.slots.changeLimit': 'Изменить лимит',
    'user.stopLoss.slots.consumedLine': 'Использовано {{date}}',
    'user.stopLoss.slots.consumedDetail': 'Сработало на {{plan}} при {{amount}}.',
    'user.stopLoss.slots.planFallback': 'План',
    'user.stopLoss.slots.st.active': 'Активно',
    'user.stopLoss.slots.st.consumed': 'Использовано',
    'user.stopLoss.limit.tabPercentage': 'По проценту',
    'user.stopLoss.limit.tabFixed': 'По фиксированной сумме',
    'user.stopLoss.limit.stopsAt': 'Инвестиция остановится при: {{amount}}',
    'user.stopLoss.limit.placeholderFixed': 'Остановить, когда значение достигнет…',
    'user.stopLoss.limit.lossProtection': 'Защита от убытка: {{amount}} ({{pct}}%)',
    'user.stopLoss.limitType.percentage': 'Процент',
    'user.stopLoss.limitType.fixed': 'Фиксированный',
    'user.stopLoss.assign.title': 'Назначить защиту стоп-лосс',
    'user.stopLoss.assign.loadingPlans': 'Загрузка активных инвестиций…',
    'user.stopLoss.assign.allProtected': 'У всех активных инвестиций уже есть стоп-лосс.',
    'user.stopLoss.assign.planMeta': '{{tier}} · Капитал {{principal}} · Текущая {{current}}',
    'user.stopLoss.assign.protectedPlan': 'Защищаемый план: {{name}}',
    'user.stopLoss.assign.currentValue': 'Текущая стоимость: {{amount}}',
    'user.stopLoss.assign.stopLossLimit': 'Лимит стоп-лосс: {{amount}}',
    'user.stopLoss.assign.maxLoss': 'Макс. убыток: {{amount}} ({{pct}}%)',
    'user.stopLoss.assign.toastFail': 'Не удалось назначить стоп-лосс',
    'user.stopLoss.assign.toastOk': 'Защита стоп-лосс включена',
    'user.stopLoss.assign.activate': 'Включить защиту',
    'user.stopLoss.assign.activating': 'Включение…',
    'user.stopLoss.update.title': 'Обновить лимит стоп-лосс',
    'user.stopLoss.update.currentLine': 'Текущий лимит: {{amount}} ({{type}})',
    'user.stopLoss.update.newValue': 'Новое значение стоп-лосс: {{amount}}',
    'user.stopLoss.update.toastFail': 'Не удалось обновить лимит',
    'user.stopLoss.update.toastOk': 'Лимит стоп-лосс обновлён',
    'user.stopLoss.update.submit': 'Обновить лимит',
    'user.stopLoss.update.updating': 'Обновление…',
  },

  bn: {
    'user.stopLoss.slots.loading': 'স্লট লোড হচ্ছে…',
    'user.stopLoss.slots.empty': 'এখনো কোনো স্টপ-লস স্লট কেনা হয়নি।',
    'user.stopLoss.slots.protectedPlan': 'সুরক্ষিত পরিকল্পনা: {{name}}',
    'user.stopLoss.slots.principalCurrent': 'মূলধন: {{principal}} · বর্তমান: {{current}}',
    'user.stopLoss.slots.limitPct': '{{pct}}% ক্ষতি',
    'user.stopLoss.slots.distance': 'ট্রিগারের দূরত্ব: {{amount}} ({{pct}}%)',
    'user.stopLoss.slots.changeLimit': 'সীমা পরিবর্তন',
    'user.stopLoss.slots.consumedLine': '{{date}} খরচ হয়েছে',
    'user.stopLoss.slots.consumedDetail': '{{plan}}-এ {{amount}}-এ ট্রিগার।',
    'user.stopLoss.slots.planFallback': 'পরিকল্পনা',
    'user.stopLoss.slots.st.active': 'সক্রিয়',
    'user.stopLoss.slots.st.consumed': 'খরচ হয়েছে',
    'user.stopLoss.limit.tabPercentage': 'শতাংশ অনুযায়ী',
    'user.stopLoss.limit.tabFixed': 'নির্দিষ্ট মান অনুযায়ী',
    'user.stopLoss.limit.stopsAt': 'বিনিয়োগ থামবে: {{amount}}',
    'user.stopLoss.limit.placeholderFixed': 'মান পৌঁছালে থামুন…',
    'user.stopLoss.limit.lossProtection': 'ক্ষতি সুরক্ষা: {{amount}} ({{pct}}%)',
    'user.stopLoss.limitType.percentage': 'শতাংশ',
    'user.stopLoss.limitType.fixed': 'নির্দিষ্ট',
    'user.stopLoss.assign.title': 'স্টপ-লস সুরক্ষা বরাদ্দ করুন',
    'user.stopLoss.assign.loadingPlans': 'সক্রিয় বিনিয়োগ লোড হচ্ছে…',
    'user.stopLoss.assign.allProtected': 'আপনার সব সক্রিয় বিনিয়োগে ইতিমধ্যে স্টপ-লস আছে।',
    'user.stopLoss.assign.planMeta': '{{tier}} · মূলধন {{principal}} · বর্তমান {{current}}',
    'user.stopLoss.assign.protectedPlan': 'সুরক্ষিত পরিকল্পনা: {{name}}',
    'user.stopLoss.assign.currentValue': 'বর্তমান মূল্য: {{amount}}',
    'user.stopLoss.assign.stopLossLimit': 'স্টপ-লস সীমা: {{amount}}',
    'user.stopLoss.assign.maxLoss': 'সর্বোচ্চ ক্ষতি: {{amount}} ({{pct}}%)',
    'user.stopLoss.assign.toastFail': 'স্টপ-লস বরাদ্দ ব্যর্থ',
    'user.stopLoss.assign.toastOk': 'স্টপ-লস সুরক্ষা সক্রিয়',
    'user.stopLoss.assign.activate': 'সুরক্ষা সক্রিয় করুন',
    'user.stopLoss.assign.activating': 'সক্রিয় করা হচ্ছে…',
    'user.stopLoss.update.title': 'স্টপ-লস সীমা আপডেট',
    'user.stopLoss.update.currentLine': 'বর্তমান সীমা: {{amount}} ({{type}})',
    'user.stopLoss.update.newValue': 'নতুন স্টপ-লস মান: {{amount}}',
    'user.stopLoss.update.toastFail': 'সীমা আপডেট ব্যর্থ',
    'user.stopLoss.update.toastOk': 'স্টপ-লস সীমা আপডেট হয়েছে',
    'user.stopLoss.update.submit': 'সীমা আপডেট',
    'user.stopLoss.update.updating': 'আপডেট হচ্ছে…',
  },

  hi: {
    'user.stopLoss.slots.loading': 'स्लॉट लोड हो रहे हैं…',
    'user.stopLoss.slots.empty': 'अभी तक कोई स्टॉप-लॉस स्लॉट खरीदा नहीं।',
    'user.stopLoss.slots.protectedPlan': 'संरक्षित योजना: {{name}}',
    'user.stopLoss.slots.principalCurrent': 'मूलधन: {{principal}} · वर्तमान: {{current}}',
    'user.stopLoss.slots.limitPct': '{{pct}}% हानि',
    'user.stopLoss.slots.distance': 'ट्रिगर तक दूरी: {{amount}} ({{pct}}%)',
    'user.stopLoss.slots.changeLimit': 'सीमा बदलें',
    'user.stopLoss.slots.consumedLine': '{{date}} को उपयोग',
    'user.stopLoss.slots.consumedDetail': '{{plan}} पर {{amount}} पर ट्रिगर।',
    'user.stopLoss.slots.planFallback': 'योजना',
    'user.stopLoss.slots.st.active': 'सक्रिय',
    'user.stopLoss.slots.st.consumed': 'उपयोग किया गया',
    'user.stopLoss.limit.tabPercentage': 'प्रतिशत के अनुसार',
    'user.stopLoss.limit.tabFixed': 'निश्चित मान के अनुसार',
    'user.stopLoss.limit.stopsAt': 'निवेश यहाँ रुकेगा: {{amount}}',
    'user.stopLoss.limit.placeholderFixed': 'मूल्य पहुँचने पर रोकें…',
    'user.stopLoss.limit.lossProtection': 'हानि सुरक्षा: {{amount}} ({{pct}}%)',
    'user.stopLoss.limitType.percentage': 'प्रतिशत',
    'user.stopLoss.limitType.fixed': 'निश्चित',
    'user.stopLoss.assign.title': 'स्टॉप-लॉस सुरक्षा असाइन करें',
    'user.stopLoss.assign.loadingPlans': 'सक्रिय निवेश लोड हो रहे हैं…',
    'user.stopLoss.assign.allProtected': 'आपके सभी सक्रिय निवेशों पर पहले से स्टॉप-लॉस है।',
    'user.stopLoss.assign.planMeta': '{{tier}} · मूलधन {{principal}} · वर्तमान {{current}}',
    'user.stopLoss.assign.protectedPlan': 'संरक्षित योजना: {{name}}',
    'user.stopLoss.assign.currentValue': 'वर्तमान मूल्य: {{amount}}',
    'user.stopLoss.assign.stopLossLimit': 'स्टॉप-लॉस सीमा: {{amount}}',
    'user.stopLoss.assign.maxLoss': 'अधिकतम हानि: {{amount}} ({{pct}}%)',
    'user.stopLoss.assign.toastFail': 'स्टॉप-लॉस असाइन विफल',
    'user.stopLoss.assign.toastOk': 'स्टॉप-लॉस सुरक्षा सक्रिय',
    'user.stopLoss.assign.activate': 'सुरक्षा सक्रिय करें',
    'user.stopLoss.assign.activating': 'सक्रिय कर रहे हैं…',
    'user.stopLoss.update.title': 'स्टॉप-लॉस सीमा अपडेट करें',
    'user.stopLoss.update.currentLine': 'वर्तमान सीमा: {{amount}} ({{type}})',
    'user.stopLoss.update.newValue': 'नया स्टॉप-लॉस मान: {{amount}}',
    'user.stopLoss.update.toastFail': 'सीमा अपडेट विफल',
    'user.stopLoss.update.toastOk': 'स्टॉप-लॉस सीमा अपडेट हुई',
    'user.stopLoss.update.submit': 'सीमा अपडेट करें',
    'user.stopLoss.update.updating': 'अपडेट हो रहा है…',
  },
};
